import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/material/examples/multi-conversation/multi-conversation.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
